import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { AuthProvider } from "./contexts/auth-context";
import { routes } from "./routes";
import { RouterProvider } from "react-router-dom";
import { ConfirmModalProvider } from "./contexts/confirm-modal-context";

const theme = createTheme({
  palette: {
    primary: {
      main: "rgb(31, 41, 156)",
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <ConfirmModalProvider>
          <ToastContainer />
          <RouterProvider router={routes} />
        </ConfirmModalProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);
